import React from 'react';
import * as rts from '../../constants/routes';

function PageNotFound() {
    return <div style={{ position: 'fixed', width: '100%', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ textAlign: 'center' }}>
            <h2 style={{ fontSize: '32px', fontWeight: 'bold' }}>404 - Page not found</h2>
            <p style={{ fontSize: '16px' }}>Oops!  We can't seem to find the page you're looking for.</p>
            <div style={{ marginTop: '16px', marginBottom: '16px' }}>
                <button
                    type='button'
                    style={{
                        display: 'inline-block',
                        fontWeight: '500',
                        color: '#fff',
                        textAlign: 'center',
                        verticalAlign: 'middle',
                        userSelect: 'none',
                        backgroundColor: '#1dc9b7',
                        border: '1px solid #1dc9b7',
                        padding: '0.8rem 1.6rem',
                        fontSize: '1.1rem',
                        lineHeight: '1.47',
                        marginRight: '10px'
                    }}
                    onClick={() => {
                        window.location.href = rts.Appointments.Home;
                    }}
                >
                    Back to Home
                </button>
            </div>
        </div>
    </div>
}

export default PageNotFound;